import { render, staticRenderFns } from "./main.vue?vue&type=template&id=27a9b182&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=27a9b182&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9b182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a9b182')) {
      api.createRecord('27a9b182', component.options)
    } else {
      api.reload('27a9b182', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=27a9b182&scoped=true&", function () {
      api.rerender('27a9b182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/rosseti/main.vue"
export default component.exports